<template>
  <input
    :name="name"
    :value="value"
    @input="updateValue($event.target.value)"
    :placeholder="placeholder"
    type="text"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>
